import { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
// store
import AppStore from "@/app-store";
import Store from "@/core/reducers/SimpleServiceStore";
// actions
import ClientPagesServiceAction from "@/cms/actions/services/ClientPagesServiceAction";
// types
import TOdataQueryOptions from "@/core/types/TOdataQueryOptions";
import TBaseReduxStoreState from "@/core/types/TBaseReduxStoreState";
import TClientPageList from "@/cms/types/TClientPageList";


type TUsePageSearch = {

    search: (searchPayload:any ) => void;

} & TBaseReduxStoreState<TClientPageList[]|null>

const usePageSearch = ( unqKey:string ):TUsePageSearch => {
    const dispatch = useDispatch();

    const _unqKey = `${unqKey}CL`;

    const clientPagesServiceAction = new ClientPagesServiceAction(dispatch, _unqKey);
    AppStore.reducerManager.add(_unqKey, Store(_unqKey, clientPagesServiceAction.serviceCode));
    const payload = useSelector((state:any) => state?.[_unqKey]?.list, shallowEqual);
    const webApplicationLanguageCode = useSelector((state:any) => state.CoreStore.language?.payload?.code, shallowEqual);

    useEffect(() => { return () => { AppStore.reducerManager.remove(_unqKey); } }, []);

    const search = (searchPayload:any ) => {
        let queryOptions:TOdataQueryOptions = {
            count: true,
            filter: searchPayload.filters,
            orderBy: searchPayload.orders,
            top: searchPayload.top,
            skip: searchPayload.skip,
            expands: ["tags"]
        }
        clientPagesServiceAction.search({ servicePayload: { queryOptions, language: webApplicationLanguageCode } });
    }

    return {
        ...payload,
        search,
    }
}

export default usePageSearch;
